// src/mobile_pages/materials/MaterialView.jsx
import { useParams } from "react-router-dom";
import MobileFormViewManager from "../../components/common/mobile/MobileFormViewManager";
import MobileMaterialViewContent from "./MobileMaterialViewContent";

export default function MaterialViewer() {
  const { id: projectId, formId, postId } = useParams();
  const dns = formId || postId;

  return (
    <div
      className="mobile-page-root mb-16"
      style={{ width: '100%', maxWidth: '100vw', minWidth: 0, display: 'flex', justifyContent: 'center', overflowX: 'hidden', boxSizing: 'border-box' }}
    >
      <div
        className="mobile-page-root-inner space-y-3"
        style={{ width: '100%', maxWidth: '480px', margin: '0 auto', padding: '0 1rem 1rem', boxSizing: 'border-box', overflowX: 'hidden' }}
      >
        <MobileFormViewManager
          params={{
            project: projectId,
            dns,
            module: "materials",
            doc_type: "MATERIAL",
          }}
          doc_name="자재 문서"
        >
          {/* 🔥 데스크탑용 테이블 뷰 대신 모바일 전용 컨텐츠 사용 */}
          <MobileMaterialViewContent />
        </MobileFormViewManager>
      </div>
    </div>
  );
}
